namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_file, {
		
		background: {
			color: $mol_theme.card,
		},

		Content_scroll: {
			overflow: 'hidden',
		},

		Fullsize_wrapper: {
			minWidth: 0,
			maxWidth: '100%',
			overflow: 'hidden',
		},

		Title: {
			boxSizing: 'border-box',
			width: '100%',
			minWidth: 0,
			lineHeight: 'normal',
			padding: $mol_gap.text,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			display: 'block',
		},

		Size_badge: {
			position: 'absolute',
			top: $mol_gap.space,
			right: $mol_gap.space,
			zIndex: $mol_layer.float,
			padding: {
				left: $mol_gap.space,
				right: $mol_gap.space,
				top: '2px',
				bottom: '2px',
			},
			border: {
				radius: '4px',
			},
			background: {
				color: $mol_theme.back,
			},
			color: $mol_theme.text,
			outline: '1px solid var(--mol_theme_text)',
			font: {
				size: '12px',
			},
			lineHeight: 'normal',
			pointerEvents: 'none',
		},

		Player: {
			flex: {
				grow: 0,
			},
		},

		Baza_download_progress: {
			position: 'relative',
			minHeight: '24px',
			margin: {
				left: $mol_gap.text,
				right: $mol_gap.text,
				bottom: $mol_gap.text,
			},
			background: {
				color: $mol_theme.back,
			},
			border: {
				radius: '4px',
			},
			overflow: 'hidden',
		},

		Baza_upload_progress: {
			position: 'relative',
			minHeight: '24px',
			margin: {
				left: $mol_gap.text,
				right: $mol_gap.text,
				bottom: $mol_gap.text,
			},
			background: {
				color: $mol_theme.back,
			},
			border: {
				radius: '4px',
			},
			overflow: 'hidden',
		},

		Baza_download_progress_bar: {
			position: 'absolute',
			left: 0,
			top: 0,
			bottom: 0,
			background: {
				color: $mol_theme.line,
			},
		},

		Baza_upload_progress_bar: {
			position: 'absolute',
			left: 0,
			top: 0,
			bottom: 0,
			background: {
				color: $mol_theme.line,
			},
		},

		Baza_download_progress_status: {
			position: 'relative',
			padding: {
				left: $mol_gap.text,
				right: $mol_gap.text,
				top: '2px',
				bottom: '2px',
			},
			font: {
				size: '12px',
			},
			lineHeight: '20px',
		},

		Baza_upload_progress_status: {
			position: 'relative',
			padding: {
				left: $mol_gap.text,
				right: $mol_gap.text,
				top: '2px',
				bottom: '2px',
			},
			font: {
				size: '12px',
			},
			lineHeight: '20px',
		},
		
	} )
	
}
